import React from 'react';
import { Card } from 'primereact/card';
import { useLanguage } from '../../../contexts/LanguageContext';
import { PRIMARY, SectionTitle, LinkRow, cardStyle, cardPt } from '../components/LmsSectionCard';
import { useLmsPermission } from '../hooks/useLmsPermission';
import { LMS } from '../../../constants/permissionCodes';

const MyTrainings = () => {
    const { th } = useLanguage();
    const { can } = useLmsPermission();
    // Linksiz satırlar (codes yok) herkese görünür
    const visible = (item) => !item.codes || can(item.codes);

    const periodsAndCatalogItems = [
        { key: 'catalog', icon: 'pi-book', to: '/learning-management-system/training-catalog', codes: [LMS.TRAINING_VIEW] },
        { key: 'planning', icon: 'pi-calendar-plus', to: '/learning-management-system/training-planning', codes: [LMS.TRAINING_VIEW] }
    ].filter(visible);

    const planningItems = [
        { key: 'trainingReport', icon: 'pi-sitemap', to: '/learning-management-system/training-report', codes: [LMS.REPORT_VIEW] },
        { key: 'createTrainingRequest', icon: 'pi-plus-circle', to: '/learning-management-system/training-request', codes: [LMS.REQUEST_VIEW] },
        { key: 'tenderRequest', icon: 'pi-briefcase', to: '/learning-management-system/tender-request', codes: [LMS.REQUEST_VIEW] },
        { key: 'planCalendar', icon: 'pi-calendar-times' },
        { key: 'repeatRequiredTrainings', icon: 'pi-refresh' }
    ].filter(visible);

    return (
        <div>
            <h1 className="mb-4" style={{ color: PRIMARY }}>
                {th('myTrainings.pageTitle', { fallback: 'Eğitim İşlemleri' })}
            </h1>

            <div className="grid">
                {periodsAndCatalogItems.length > 0 && (
                    <div className="col-12">
                        <Card style={cardStyle} pt={cardPt}>
                            <SectionTitle title={th('myTrainings.periodsAndCatalog.title', { fallback: 'Eğitim Dönemleri ve Katalog' })} />
                            {periodsAndCatalogItems.map((item, index) => (
                                <LinkRow key={item.key} title={th(`myTrainings.periodsAndCatalog.${item.key}`)} icon={item.icon} to={item.to} showDivider={index < periodsAndCatalogItems.length - 1} />
                            ))}
                        </Card>
                    </div>
                )}

                <div className="col-12">
                    <Card style={cardStyle} pt={cardPt}>
                        <SectionTitle title={th('myTrainings.planning.title', { fallback: 'Eğitim Planlama İşlemleri' })} />
                        {planningItems.map((item, index) => (
                            <LinkRow key={item.key} title={th(`myTrainings.planning.${item.key}`)} icon={item.icon} to={item.to} showDivider={index < planningItems.length - 1} />
                        ))}
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default MyTrainings;
